import Component from '../abstracts/Component';
import vex from 'vex-js';

export default class ModalComponent extends Component {
  get SELECTORS() {
    return {
      trigger: '[data-modal]',
      container: '.vex',
      focusableEl: 'a, :input:not([type=hidden]), button, [tabindex], iframe, :input:not(.form-group__username)'
    }
  }

  get LIBRARIES_SELECTORS() {
    return {
      tab: '[data-tabs]',
      select: 'select',
      // selectWithinModal: '.vex-content select',
      fakeSelectToCleanUp: 'select.select2-hidden-accessible + span.select2-container'
    }
  }

  get CLASSES () {
    return {
      canScroll: 'can-scroll'
    }
  }

  constructor() {
    super();
    this.focusableEl = $(this.SELECTORS.focusableEl);
  }

  modalAfterOpen(vexInstance, closeText, overflow) {
    let $close =  $(vexInstance.closeEl);
    let $container = $(vexInstance.rootEl);
    let closeLabel = closeText;

    if (closeText) {
      $close.text(closeLabel).addClass('cta-close')
    }

    if (overflow === 'auto') {
      $('body').addClass(this.CLASSES.canScroll);
    }


    let $tabs = $container.find(this.LIBRARIES_SELECTORS.tab);
    if ($tabs.length > 0) {
      this.moduleLoader.loadBootstrapJsComponentAndExecute("tab",
        (module) => {
          $(this.LIBRARIES_SELECTORS.tab).tab();
          this.log('Tab initialized');
        },
        (error) => {
          console.log("failed to load tabs ", error.stack);
        }
      )
    }

    let $select = $container.find(this.LIBRARIES_SELECTORS.select);

    if ($select.length > 0) {
      this.moduleLoader.loadSelect2(
        (module) => {
          $container.find(this.LIBRARIES_SELECTORS.fakeSelectToCleanUp).remove()
          const $selectEl = $(this.LIBRARIES_SELECTORS.select);

          $selectEl.each(function () {
            let ctx =  $(this);
            ctx.select2({
              minimumResultsForSearch: Infinity
            });
          });
        },
        (error) => {
          console.log("failed to load select2 ", error.stack);
        }
      );
    }

    //ADD ACCESSIBILITY PROPERTIES
    $container.attr('tabindex', -1).attr('role', 'dialog');
    $close.attr('role', 'button').attr('tabindex', 0);

    if (!vexInstance.rootEl.classList.contains('privacy-modal')) {
      let $focusableEl = $container.find(this.SELECTORS.focusableEl);
      $focusableEl.first().focus();
    }

    $close.off('keydown.Modals').on('keydown.Modals', function (e) {
      if (e.keyCode === 13) {
        // vex.close(vexInstance);
      }
    });

    document.querySelectorAll('.js-recover-shipping-address .js-forceUppercase').forEach(function (uppercaseElement) {
      uppercaseElement.addEventListener('input', function () {
        uppercaseElement.value = this.value.toUpperCase();
      });
    });
  }

  getRequestBody (el) {
    try {
      const body = el.data('body');
      return typeof body === "string" ? JSON.parse(el.data('body')) : body;
    } catch (e) {
      return {}
    }
  }

  openAjaxContent(el) {
    let ctx = this;
    let url = el.data('href') || el.attr('href');
    let title = el.data('title');
    let close = el.data('closeText');
    let overlayClass = el.data('overlayClass');
    let overflow = el.data('overflow');
    let dataEgonValidation = el.data('egonValidation');
    let method = el.data('method') || 'GET';
    let body = method.toUpperCase() === 'POST' ? this.getRequestBody(el) : null;

    $(el).addClass('disable-click');

    $.ajax({
      type: method,
      url: url,
      data: body,
      contentType: body ? "application/json; charset=utf-8" : undefined,
    }).then(resp => {
      let chunked = $(resp).find('[data-ajax-chunk]');

      if (typeof resp !="object" && chunked.length) {
        resp = chunked.html();
      }

      vex.open({
        unsafeContent: this.wrappedContent(resp, title)[0].outerHTML,
        className: el.data('modalClass'),
        afterOpen: function() {
          setTimeout(function(){
            $('body').trigger("formInitializeAll");
          }, 1000);
          ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterOpen);
          ctx.modalAfterOpen(this, close, overflow);
          if (dataEgonValidation === true) {
            ctx.$emit(ctx.$customEvents.MODAL_EVENTS.egonValidation);
          }
        },
        afterClose: function() {
          ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterClose, this);
          $('body').removeClass(ctx.CLASSES.canScroll);
          $(el).removeClass('disable-click');
        },
        overlayClassName: overlayClass
      });
    });
  }

  openStaticContent(el) {
    let ctx = this;
    let title = el.data('title');
    let close = el.data('closeText');
    let content = $(el.data('modalId'))[0].outerHTML;

    $(el).addClass('disable-click');

    vex.open({
      unsafeContent: this.wrappedContent(content, title)[0].outerHTML,
      className: el.data('modalClass'),
      afterOpen: function() {
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterOpen);
        ctx.modalAfterOpen(this, close);
      },
      afterClose: function() {
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterClose, this);
        $('body').removeClass(ctx.CLASSES.canScroll);
        $(el).removeClass('disable-click');
      }
    });
  }

  openRemoteContent(conf) {
    let title = $(conf.unsafeContent).data('title');
    let close = $(conf.unsafeContent).data('closeText');
    const ctx = this;
    let classData = $(conf.unsafeContent).data('modalClass');
    if(conf.modalClass){
      classData = conf.modalClass ;
    }
    if (conf.canScroll) document.body.classList.add(this.CLASSES.canScroll);
    vex.open({
      unsafeContent: this.wrappedContent(conf.unsafeContent, title)[0].outerHTML,
      className: classData,
      afterOpen: function () {
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterOpen);
        ctx.modalAfterOpen(this, close);
      },
      afterClose: function () {
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterClose, this);
        $('body').removeClass(ctx.CLASSES.canScroll);
      }
    });
  }

  wrappedContent(content, title) {

    let container = $(`<div class="modal-content"></div>`);
    if (title) {
      let $header = $(`<div class="modal-header"><h2 class="h2-tertiary">${title}</div>`);
      container.append($header);
    } else {
      container.addClass('no-header')
    }
    if (content) {
      let $body = $(`<div class="modal-body">${content}</div>`);
      container.append($body);
    }
    return container;

  }

  openModalByGet(get){
    let params = (new URL(document.location)).searchParams;
    let param = params.get(get);
    if(param == 'true') {
      let $el = $('#'+get);
      this.openStaticContent($el);
    }
  }


  bindEvents() {
    this.$on('click.modal', ({event}) => {
      event.preventDefault();
      let $el = $(event.currentTarget);
      if ($el.data('modalId') ) {
        this.openStaticContent($el);
      } else {
        this.openAjaxContent($el);
      }
    }, 'body', this.SELECTORS.trigger);

    // Modal when calling from outside
    this.$on(this.$customEvents.MODAL_EVENTS.show, ({payload}) => {
      this.openRemoteContent(payload);
    });

    // this.$on(this.$customEvents.MODAL_EVENTS.afterUpdateContent, ({payload}) => {
    //   let $selects = $(this.LIBRARIES_SELECTORS.selectWithinModal);
    //   if ($selects.length > 0) {
    //     this.moduleLoader.loadSelect2(
    //       () => {
    //         $selects.each(function () {
    //           $(this).select2({
    //             minimumResultsForSearch: Infinity
    //           });
    //         });
    //       },
    //       (error) => {
    //         console.log("failed to load select2 ", error.stack);
    //       }
    //     );
    //   }
    // });
  }

  render() {
    this.bindEvents();
    this.openModalByGet('socialError');
  }
}
